const t = true,
  f = false;
const dev = f;

let state = {
  dev,
  devmode: f,
  cloudurl: "",
  index: {},
  api: {
    // todo: finish adding actions and mutations to available methods
    actions: [
      {},
      {
        name: "detecttype",
        description: "Returns type of data",
        returntype: String,
        inputs: [],
      },
      {
        name: "validjson",
        description: "Checks if a string is valid JSON",
        returntype: Boolean,
        inputs: [String],
      },
      {
        name: "util",
        description:
          'Calls utility functions. payload.type should be "right, filter, if, map, set, or delete, help"',
        type: String,
        inputs: [Object],
      },
      {
        name: "api",
        description: "REST requests",
        returntype: Object,
        inputs: {
          verb: String,
          data: Object,
          address: String,
          hook: Object,
          config: Object,
        },
      },
      {
        name: "run",
        description: "Runs functions and returns result (fun is the fn id)",
        returntype: Object,
        inputs: [{ fun: String, payload: Object, if: Array, hook: Object }],
      },
      {
        name: "auth",
        description: "Authentication functions",
        inputs: { type: String },
        types: {
          token: {
            inputs: { token: String },
            description: "Logs in with a valid token",
          },
          signinwithemaillink: { description: "logs in a user from valid url" },
          email: {
            description: "logs user in with email and password",
            inputs: { email: String, password: String },
          },
          social: {
            description: "logs user in with OAUTH provider",
            inputs: { provider: String },
          },
          create: {
            description: "creates new user with email and password",
            email: String,
            password: String,
            requirements: Object,
          },
          reset: {
            description: "sends password reset email",
            inputs: { email: String },
          },
          magiclink: {
            description: "Emails a link to sign in.",
            inputs: { email: String },
          },
          completesignup: { description: "Password creation for new users" },
          changepass: {
            description: "Password change",
            inputs: { pass: String },
          },
          logout: { description: "logs user off" },
          usercheck: {
            description: "checks if an email is registered",
            inputs: { email: String },
          },
          currentuser: { description: "returns current user", inputs: {} },
        },
      },
      {
        name: "create",
        description: "Creates content",
        inputs: { type: String, data: Object },
        types: {
          app: {
            description: "create a new application",
            inputs: {
              type: "app",
              data: {
                basics: Object,
                style: Object,
                pages: Object,
                users: Object,
              },
            },
          },
          fromdata: {
            description: "creates an item type from a data model",
            inputs: { data: { model: Object, name: String } },
          },
          msg: {
            description: "creates a message",
            inputs: {
              data: {
                topic: String,
                users: Array,
                type: String,
                banter: { [Date.now()]: { text: String, user: String } },
              },
            },
          },
          notification: {
            description: "creates a notification",
            inputs: {
              data: {
                actions: Array,
                subMessage: String,
                from: String,
                link: String,
                message: String,
                to: Array,
                type: String,
              },
            },
          },
          comments: {
            description: "creates a comment at a given resource",
            inputs: {
              comment: {
                id: String,
                text: String,
                type: String,
                user: String,
                timestamp: Date,
              },
            },
          },
          reputation: {
            description: "creates a reputation",
            inputs: { content: String, quality: Number },
          },
          order: {
            description: "creates an order",
            inputs: {
              cart: Object,
              data: { Shipping: Object, Payment: Object },
            },
          },
          value: {
            description: "creates a user value",
            inputs: { datatype: String, key: String, value: String },
          },
          item: {
            description: "creates item",
            inputs: { type: String, data: Object },
          }, // This might work as a default
        },
      },
    ],
    mutations: {},
  },
  app: {
    basics: {
      database: encodeURIComponent(window.location.hostname),
      ["app name"]: encodeURIComponent(window.location.hostname),
      items: [],
      modules: [],
      api: [],
    },
  },
  auth: {},
  commentCounts: {},
  commentListeners: {},
  components: {
    admin: [
      "admin",
      "agent",
      "assign",
      "api",
      "debug",
      "function",
      "hooks",
      "if",
      "imanage",
      "import",
      "logs",
      "pageadmin",
      "smartcontracts",
    ],
    display: [
      "browse",
      "createitem",
      "foot",
      "layout",
      "pages",
      "row",
      "single",
    ],
    instance: [
      "apply",
      "attend",
      "cart",
      "comments",
      "events",
      "jobs",
      "login",
      "media",
      "message",
      "notifications",
      "pointer",
      "reviews",
      "search",
      "smartcontract",
      "state",
    ],
    views: [
      "admin",
      "auction",
      "completesignup",
      "hello",
      "home",
      "onboard",
      "single",
      "xmbl",
    ],
    uxui: [
      "add",
      "copy",
      "icontent",
      "iform",
      "iiframe",
      "iitem",
      "ilink",
      "ilist",
      "iinput",
      "ipage",
      "islide",
      "itable",
      "itime",
      "inav",
      "rm",
      "short",
      "ui",
    ],
    widgets: [
      "action",
      "auctions",
      "buy",
      "completesignup",
      "dashboard",
      "hello",
      "home",
      "maps",
      "navigation",
      "onboard",
      "orders",
      "profile",
      "reputation",
      "sales",
      "terminal",
      "aichat",
      "tokens",
      "user",
      "wallet",
      "widget",
      "xmbl",
    ],
  },
  connectivity: {},
  counter: 1,
  counts: {
    terminal: 1,
    buy: 1,
    cart: 0,
    cheating: {},
    componentKey: 0,
    edit: 0,
    messages: 0,
    notifications: 0,
    ordersIter: 1,
    jobs: 0,
    events: 0,
    reviews: 0,
    salesIter: 1,
    state: 0
  },
  decoded: {},
  debug: f,
  defaults: {
    userimage:
      "https://preview.redd.it/p61ulijkxr751.jpg?width=320&crop=smart&auto=webp&s=342130582bd6c2aadf98b94a936f57bab25ea1aa",
    logo: "",
  },
  device: {
    language: window.navigator.language,
    mobile: "ontouchstart" in window || navigator.msMaxTouchPoints,
    online: window.navigator.onLine,
    platform: window.navigator.platform,
    product: window.navigator.product,
    userAgent: window.navigator.userAgent,
    vendor: window.navigator.vendor,
  },
  functions: {
    dispatch: {
      set: {
        desc: "State data mutation",
        payload: { keys: Array, val: Object, key: String },
      },
      detecttype: {
        desc: "Returns type of data",
        payload: t,
      },
      validjson: {
        desc: "Checks if a string is valid JSON",
        payload: String,
      },
      util: {
        desc: "Utility functions.",
        typerequired: t,
        payload: t,
        types: {
          right: {
            desc: "Applies a right-side function to some data",
            payload: {
              item: Object,
              fn: String,
              args: Array,
            },
          },
          filter: {
            desc: "Filters an array",
            payload: {
              iter: Array,
              fn: Function,
            },
          },
          if: {
            desc: "Runs a conditional check",
            payload: {
              comparitor: String,
              conditions: Array,
            },
          },
          map: {
            desc: "Maps a function to items in an array",
            payload: { iter: Array, fn: Function },
          },
          set: {
            desc: "Sets a value to a property in an object or to an index of an array",
            payload: { obj: Object, prop: String, val: Object },
          },
          delete: {
            desc: "Removes a value from a property in an object or from an index of an array",
            payload: { obj: Object, prop: String },
          },
          qr: {
            desc: "Generates QR code for an object",
            payload: { obj: Object },
          },
          decodewm: {
            desc: "Decodes watermark from URL",
            payload: { url: String, id: String },
          },
          cbor2str: {
            desc: "Converts CBOR hex to string",
            payload: { cbor: String },
          },
          hex2str: { desc: "Converts hex to string", payload: { hex: String } },
          order: {
            desc: "Orders array or object by property",
            payload: { data: Array, prop: String, direction: String },
          },
          hash: {
            desc: "Generates SHA256 hash",
            payload: { body: Object, count: Number },
          },
          encode: {
            desc: "Encodes data to various formats",
            payload: { type: String, data: Object },
          },
          decode: {
            desc: "Decodes data from various formats",
            payload: { type: String, data: Object },
          },
          normalize: {
            desc: "Normalizes string by replacing spaces and special chars",
            payload: { str: String },
          },
          help: {
            desc: "Returns help information for utility functions",
            payload: {},
          },
        },
      },
      api: {
        desc: "Hits RESTful endpoints. Verb must be type of get, post, delete, or patch.",
        payload: {
          verb: String,
          data: Object,
          address: String,
          hook: Object,
          config: Object,
        },
      },
      if: {
        desc: "Checks some conditions",
        payload: {
          item: Object,
          data: Object,
          conditions: Array,
          name: String,
        },
      },
      run: {
        desc: "Function runner",
        payload: { fun: Object, payload: Object, if: Array, hook: Object },
      },
      auth: {
        desc: "Authentication functions",
        typerequired: t,
        payload: t,
        types: {
          token: {
            desc: "Logs in with a valid token",
            payload: { token: String },
          },
          signinwithemaillink: { desc: "logs in a user from valid url" },
          email: {
            desc: "logs user in with email and password",
            payload: { email: String, password: String },
          },
          social: {
            desc: "logs user in with OAUTH provider",
            payload: { provider: String },
          },
          create: {
            desc: "creates new user with email and password",
            email: String,
            password: String,
            requirements: Object,
          },
          reset: {
            desc: "sends password reset email",
            payload: { email: String },
          },
          magiclink: {
            desc: "Emails a link to sign in.",
            payload: { email: String },
          },
          completesignup: { desc: "Password creation for new users" },
          changepass: { desc: "Password change", payload: { pass: String } },
          logout: { desc: "logs user off" },
          usercheck: {
            desc: "checks if an email is registered",
            payload: { email: String },
          },
          currentuser: { desc: "returns current user" },
        },
      },
      create: {
        desc: "Create items and app content",
        typerequired: t,
        types: {
          app: {
            desc: "create a new application",
            payload: {
              data: {
                basics: Object,
                style: Object,
                pages: Object,
                users: Object,
              },
            },
          },
          fromdata: {
            desc: "creates an item type from a data model",
            payload: { data: { model: Object, name: String } },
          },
          msg: {
            desc: "creates a message",
            payload: {
              data: {
                topic: String,
                users: Array,
                type: String,
                banter: { [Date.now()]: { text: String, user: String } },
              },
            },
          },
          notification: {
            desc: "creates a notification",
            payload: {
              data: {
                actions: Array,
                subMessage: String,
                from: String,
                link: String,
                message: String,
                to: Array,
                type: String,
              },
            },
          },
          comments: {
            desc: "creates a comment at a given resource",
            payload: {
              comment: {
                id: String,
                text: String,
                type: String,
                user: String,
                timestamp: Date,
              },
            },
          },
          reputation: {
            desc: "creates a reputation",
            payload: { content: String, quality: Number },
          },
          order: {
            desc: "creates an order",
            payload: {
              cart: Object,
              data: { Shipping: Object, Payment: Object },
            },
          },
          value: {
            desc: "creates a user value",
            payload: { datatype: String, key: String, value: String },
          },
          item: {
            desc: "creates item",
            payload: { type: String, data: Object },
          }, // TODO check if this might work as a default
        },
      },
      query: {
        desc: "Gets data associated with an item or app content.",
        typerequired: t,
        types: {
          list: {
            desc: "Gets a collection of items",
            payload: {
              collection: String,
              limit: Number,
            },
          },
          item: {
            desc: "Gets a specific item",
            payload: {
              collection: String,
              id: String,
            },
          },
          reputation: {
            desc: "Gets a reputation entry",
            payload: { id: String },
          },
          user: {
            desc: "Gets user data",
            payload: { id: String },
          },
        },
      },
      update: {
        desc: "Update items and app content",
        typerequired: t,
        types: {
          app: {
            desc: "Update application",
            payload: {
              data: {
                basics: Object,
                style: Object,
                pages: Object,
                users: Object,
              },
            },
          },
          msg: {
            desc: "Updates a message",
            payload: {
              data: {
                topic: String,
                users: Array,
                type: String,
                banter: { [Date.now()]: { text: String, user: String } },
              },
            },
          },
          notification: {
            desc: "creates a notification",
            payload: {
              data: {
                actions: Array,
                subMessage: String,
                from: String,
                link: String,
                message: String,
                to: Array,
                type: String,
              },
            },
          },
          comments: {
            desc: "creates a comment at a given resource",
            payload: {
              comment: {
                id: String,
                text: String,
                type: String,
                user: String,
                timestamp: Date,
              },
            },
          },
          reputation: {
            desc: "creates a reputation",
            payload: { content: String, quality: Number },
          },
          order: {
            desc: "creates an order",
            payload: {
              cart: Object,
              data: { Shipping: Object, Payment: Object },
            },
          },
          value: {
            desc: "creates a user value",
            payload: { datatype: String, key: String, value: String },
          },
          item: {
            desc: "creates item",
            payload: { type: String, data: Object },
          }, // TODO check if this might work as a default
        },
      },
      delete: {
        desc: "Deletes items and app content",
        payload: { id: String, type: String },
      },
      relate: {
        desc: "Manages relationships between items",
        payload: {
          type: String,
          itemType: String,
          id: String,
          status: String,
          secret: Boolean,
        },
      },
      token: {
        desc: "Token operations",
        payload: { type: String, pk: String, tx: Object },
      },
      transact: {
        desc: "Transaction processing",
        payload: {
          type: String,
          payment: Object,
          orderId: String,
          fullOrder: Object,
        },
      },
      upload: {
        desc: "Uploads files",
        payload: { files: Array },
      },
      import: {
        desc: "Imports data from JSON file",
        payload: { files: Array },
      },
      export: {
        desc: "Exports data to JSON file",
        payload: { type: String, name: String, data: Object },
      },
      blockfrostipfs: {
        desc: "Pins file to IPFS via Blockfrost",
        payload: { file: Object, client: String },
      },
      crypto: {
        desc: "Cryptocurrency operations",
        payload: { type: String, data: Object },
      },
      indexer: {
        desc: "Indexes data for search",
        payload: { obj: Object, id: String, type: String, olditem: Object },
      },
      init: {
        desc: "Initializes application state",
        payload: { styleonly: Boolean, stateonly: Boolean },
      },
      ipfs: {
        desc: "IPFS operations",
        payload: { payload: Object },
      },
      notify: {
        desc: "Creates notification",
        payload: {
          type: String,
          message: String,
          to: Array,
          from: String,
          link: String,
          id: String,
          subMessage: String,
          actions: Array,
        },
      },
      schedule: {
        desc: "Schedules events",
        payload: { command: String, time: Number, payload: Object },
      },
      hashtable: {
        desc: "Hash table operations",
        payload: { contract: Object, type: String },
      },
      t: {
        desc: "Tokenization operations",
        payload: { type: String, payload: Object, gettoken: Boolean },
      },
      worker: {
        desc: "Web worker operations",
        payload: { str: String },
      },
      getlocalstate: {
        desc: "Gets local state from localStorage",
        payload: {},
      },
      setlocalstate: {
        desc: "Sets local state to localStorage",
        payload: {},
      },
      ai: {
        desc: "AI assistant with ollama integration",
        payload: {
          prompt: String,
          context: Array,
          model: String,
          functions: Array,
        },
      },
      getAvailableActions: {
        desc: "Lists all available actions in the app",
        payload: {},
      },
      listFeatures: {
        desc: "Provides information about the features of the xmbl app",
        payload: {},
      },
      getCurrentUser: {
        desc: "Gets current user information and authentication status",
        payload: {},
      },
      getOllamaModels: {
        desc: "Gets available Ollama models",
        payload: {},
      },
      secrets: {
        desc: "Manages secrets",
        typerequired: t,
        types: {
          share: {
            desc: "Splits a secret",
            payload: { str: String, shares: Number, thresh: Number },
          },
          combine: {
            desc: "Combines shares",
            payload: { shares: Array },
          },
        },
      },
    },
    commit: {
      set: {
        desc: "Sets some value to some state location",
        payload: { key: String, keys: Array, val: Object },
      },
      closeAll: {
        desc: "Closes all views except specified ones",
        payload: { only: Array, except: Array },
      },
      log: {
        desc: "Logs data to console",
        payload: { logname: String, payload: Object },
      },
      point: {
        desc: "Creates a pointer notification",
        payload: {
          header: String,
          text: String,
          link: String,
          sticky: Boolean,
          speed: Number,
          type: String,
          time: Number,
        },
      },
      route: {
        desc: "Navigates to a route",
        payload: { type: String, id: String },
      },
      setState: {
        desc: "Sets state properties",
        payload: { items: Boolean, prop: String, prop2: String, val: Object },
      },
      setMeta: {
        desc: "Sets meta tags",
        payload: {},
      },
      setStyle: {
        desc: "Sets application styles",
        payload: {},
      },
      setScript: {
        desc: "Sets custom scripts",
        payload: {},
      },
      showhide: {
        desc: "Toggles show/hide for a property",
        payload: { prop: String },
      },
      show: {
        desc: "Toggles show/hide for nested properties",
        payload: { parent: String, key: String },
      },
      increment: {
        desc: "Increments counter",
        payload: {},
      },
      norm: {
        desc: "Normalizes string by replacing spaces with underscores",
        payload: { string: String },
      },
    },
  },
  iitem: {},
  isEmail: f,
  lastuploadurls: [],
  lastuploadhash: [],
  ref: {
    image: {},
    name: {},
    title: {},
    functions: {},
  },
  related: {
    ai: {}, // matches task ids to message conversation id and context data {taskId: {messageConversationId: String, context: Object}}
    connect: {},
    data: {},
    events: {},
    jobs: {},
  },
  scrollVal: 0,
  search: {
    item: "",
    artist: "",
    context: {}
  },
  secretEvent: f,
  secretItem: f,
  show: {},
  ai: {
    config:{
      agentId: "5nA8rryyPedDsIvtWmTD0pRbann2"
    },
    agents:{
      context: {
        prompt: "",
        response: {}
      },
      introspect: {
        prompt: "",
        response: {}
      },
      converse: {
        prompt: "",
        response: {}
      },
      execute: {
        prompt: "",
        response: {}
      },
      compose: {
        prompt: "",
        response: {}
      },
      content: {
        prompt: "",
        response: {}
      },
    }, // Lists available agents with their prompts and expected responses
    tasks:{}, // keeps metadata, context, and status updates for each task {taskId: {status: String, metadata: {}, context: {}}}}
  },
  terminal: {
    inputs: {},
    currentMessage: "",
    currentConversationId: null,
    selectedModel: "llama3.2:latest",
    availableModels: [],
    selectedPrompt: null,
    showState: false,
    lastPlan: null,
    currentExecution: null,
    lastResult: null,
    validationError: null,
    executionError: null,
    deniedPlans: [],
    context: {},
    previewMode: "plan", // 'plan' or 'component'
    previewComponent: null,
    showDebugConsole: false,
    debugLogs: []
  },
  user: {},
  users: {},
  userlist: {},
  userLoaded: f,
  value: {},
  version: "1.0",
  welcomeNotificationSent: f,
  windowHeight: window.innerHeight,
  windowWidth: window.innerWidth,
};

export default state;
